/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Import translation hook
import { error404 } from "../constant/images";
import usePageTracker from "../hooks/usePageTracker";

const ErrorPage = () => {
  const { t } = useTranslation(); // Initialize translation
  usePageTracker("page_view_404");

  return (
    <div className="min-h-screen bg-[url('../images/all-img/404-bg.png')] bg-cover bg-no-repeat bg-center">
      <div className="max-w-[570px] mx-auto flex flex-col items-center text-center justify-center min-h-screen px-4">
        <img src={error404} alt="404 Error" className="mb-14" />
        <h2 className="mb-6">{t("error_page.title")}</h2>
        <div className="mb-10">{t("error_page.description")}</div>
        <Link to={"/"} className="btn btn-primary">
          {t("error_page.back_to_home")}
        </Link>
      </div>
    </div>
  );
};

export default ErrorPage;
